export { DiscountTab } from './discount-tab';
